import * as React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useParams, useLocation, useSearchParams } from 'react-router-dom';
import * as JSTool from '../store/JSTool';


export default function Survey_eu1(props) {
    const [searchParams, setSearchParams] = useSearchParams();
    const url = 'https://aplusjapan.aihelp.net/form/#/?unionId=74d2a21530914231a1c465e3e970cb9b&ep=6962780c8a259bf2f0f00c5c26db1b8d0952f1a744ad20f15952ea5bf275efa5ed4e5a516348568ff32ad6801bb5ea5f33544e4fab7a4e915ecd1145f9c303b1d2f2421e69210de7a5f212b63bcc5fbed30ea3ad6141915115d86d2e6142761960ed95e7beadc2b754ac49c41b56968b';
    React.useEffect(() => {
        const uid = searchParams.get('userId');
        if (!JSTool.isEmpty(uid)) {
            window.location.href = url + '&userId=' + uid;
        } else {
            window.location.href = url;
        }

    }, []);

    return (
        <Stack>
        </Stack>
    )
}           
